export const checkFileType = (file: File, validFileFormat: string | string[]) => {
  const validFileFormats = Array.isArray(validFileFormat)
    ? validFileFormat
    : [validFileFormat]

  return validFileFormats.includes(file.type)
}
